import { BulkUploadReportResponse } from '../../schemas/BulkUploadReport.schema';
import { MaggieHttp } from '../MaggieHttp';

export type UnSharePayload = string[];

export async function getBulkUploadReport(id: number) {
  const { data } = await MaggieHttp.maggie.get<BulkUploadReportResponse>(`/customField/upload/status/${id}`);
  return data;
}
